"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapEntryResponseToJSON = exports.MapEntryResponseFromJSONTyped = exports.MapEntryResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
function MapEntryResponseFromJSON(json) {
    return MapEntryResponseFromJSONTyped(json, false);
}
exports.MapEntryResponseFromJSON = MapEntryResponseFromJSON;
function MapEntryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': json['data'],
        'proof': !runtime_1.exists(json, 'proof') ? undefined : json['proof'],
    };
}
exports.MapEntryResponseFromJSONTyped = MapEntryResponseFromJSONTyped;
function MapEntryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data,
        'proof': value.proof,
    };
}
exports.MapEntryResponseToJSON = MapEntryResponseToJSON;
//# sourceMappingURL=MapEntryResponse.js.map